<template>
  <div class="community-fund-manage">
    <div class="vc-index-nav">
      <span><i class="el-icon-s-finance margin-right-sm"></i>费用管理</span>
      <span class="margin-left-sm margin-right-sm">/</span>
      <span>共有资金管理</span>
    </div>

    <!-- 汇总卡片 -->
    <el-row :gutter="20" class="fund-summary">
      <el-col :span="8">
        <el-card class="summary-card balance-card" shadow="hover">
          <div class="summary-label">当前余额</div>
          <div class="summary-value">¥{{ fundSummary.balance || '0.00' }}</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="summary-card income-card" shadow="hover">
          <div class="summary-label">本月收入</div>
          <div class="summary-value income">+¥{{ fundSummary.monthIncome || '0.00' }}</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="summary-card expense-card" shadow="hover">
          <div class="summary-label">本月支出</div>
          <div class="summary-value expense">-¥{{ fundSummary.monthExpense || '0.00' }}</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 筛选和操作 -->
    <el-card class="filter-card" shadow="never">
      <el-row :gutter="20" type="flex" align="middle">
        <el-col :span="6">
          <el-select v-model="filterType" placeholder="类型筛选" clearable size="small" @change="loadDetails">
            <el-option label="全部" value=""></el-option>
            <el-option label="收入" value="income"></el-option>
            <el-option label="支出" value="expense"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
            @change="loadDetails"
          ></el-date-picker>
        </el-col>
        <el-col :span="10" style="text-align: right;">
          <el-button type="success" size="small" icon="el-icon-download" @click="downloadTemplate" style="margin-right: 10px;">下载模板</el-button>
          <el-upload
            action=""
            :http-request="handleImport"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;"
          >
            <el-button type="primary" size="small" icon="el-icon-upload2">导入银行流水</el-button>
          </el-upload>
        </el-col>
      </el-row>
    </el-card>

    <!-- 明细表格 -->
    <el-card shadow="never" class="table-card">
      <el-table :data="fundDetails" border stripe style="width: 100%" v-loading="loading">
        <el-table-column prop="remark" label="摘要" min-width="200">
          <template slot-scope="scope">
            {{ parseRemarkName(scope.row.remark) }}
          </template>
        </el-table-column>
        <el-table-column prop="detailType" label="类型" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.detailType === '1001' ? 'success' : 'danger'" size="small">
              {{ scope.row.detailType === '1001' ? '收入' : '支出' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="金额" width="140">
          <template slot-scope="scope">
            <span :class="scope.row.detailType === '1001' ? 'text-income' : 'text-expense'">
              {{ scope.row.detailType === '1001' ? '+' : '-' }}¥{{ scope.row.amount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="日期" width="180">
          <template slot-scope="scope">
            {{ formatTimestamp(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="200">
          <template slot-scope="scope">
            {{ parseRemarkNote(scope.row.remark) }}
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="余额" width="120">
          <template slot-scope="scope">
            {{ scope.row.balance || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="counterparty" label="对方单位" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.counterparty || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="useType" label="用途" width="120">
          <template slot-scope="scope">
            {{ scope.row.useType || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="billNo" label="票据号" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.billNo || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="transCode" label="标识码" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.transCode || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="counterpartyAcct" label="对方账户" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.counterpartyAcct || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="settleType" label="结算方式" width="120">
          <template slot-scope="scope">
            {{ scope.row.settleType || '' }}
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="row"
        :total="total"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { listCommunityFunds, listCommunityFundDetails, uploadCommunityFundFile, importCommunityFundDetails } from '@/api/fee/communityFundApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'CommunityFundManageList',
  data() {
    return {
      loading: false,
      fundSummary: {
        balance: '0.00',
        monthIncome: '0.00',
        monthExpense: '0.00'
      },
      fundDetails: [],
      filterType: '',
      dateRange: null,
      page: 1,
      row: 10,
      total: 0
    }
  },
  created() {
    this.loadSummary()
    this.loadDetails()
  },
  methods: {
    getCommunityId() {
      return getCommunityId() || ''
    },
    loadSummary() {
      const params = { communityId: this.getCommunityId() }
      listCommunityFunds(params).then(res => {
        if (res.code === 0 && res.data) {
          this.fundSummary = res.data
        }
      }).catch(err => {
        console.error('查询共有资金汇总失败', err)
      })
    },
    loadDetails() {
      this.loading = true
      const params = {
        communityId: this.getCommunityId(),
        page: this.page,
        row: this.row,
        type: this.filterType
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0] + ' 00:00:00'
        params.endTime = this.dateRange[1] + ' 23:59:59'
      }
      listCommunityFundDetails(params).then(res => {
        if (res.code === 0) {
          this.fundDetails = res.data || []
          this.total = res.total || 0
        }
      }).catch(err => {
        console.error('查询共有资金明细失败', err)
      }).finally(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadDetails()
    },
    downloadTemplate() {
      // 生成银行对账单格式Excel模板（使用HTML表格格式，Excel可识别）
      const headers = ['日期', '摘要', '结算方式', '票据号', '收款', '付款', '余额', '对方单位', '用途', '标识码', '对方账户']
      const sampleData = [
        ['2026-06-01', 'TL20260531SL2WTF1.49', '', '1100019009CV3WGIWEZ', '571.17', '', '30478.82', '通联支付网络服务股份有限公司', '跨行转入', 'SK20260601DI2ZJ2', '9912900000582902'],
        ['2026-06-03', '个人所得税677.04', '', '442101997ECHZPUBYO5', '', '677.04', '47560.13', '待报解预算收入', '缴税', 'FK20260603DJIXS6', '']
      ]
      let html = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">'
      html += '<head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>银行流水</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>'
      html += '<body><table border="1">'
      // 表头（加粗）
      html += '<tr>'
      headers.forEach(h => { html += '<th style="font-weight:bold;background-color:#4472C4;color:#fff;padding:6px 12px;">' + h + '</th>' })
      html += '</tr>'
      // 示例数据
      sampleData.forEach(row => {
        html += '<tr>'
        row.forEach(cell => { html += '<td style="padding:4px 8px;">' + cell + '</td>' })
        html += '</tr>'
      })
      html += '</table></body></html>'
      const blob = new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '银行流水导入模板.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(link.href)
    },
    handleImport(options) {
      const file = options.file
      // 校验文件类型
      const fileName = file.name || ''
      const fileExt = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      if (fileExt !== '.xlsx') {
        this.$message.error('请上传.xlsx格式的Excel文件')
        return
      }
      // 第一步：上传文件到文件服务器
      const formData = new FormData()
      formData.append('uploadFile', file)

      uploadCommunityFundFile(formData).then(uploadRes => {
        // 上传接口返回 { fileName, realFileName }
        let fileUrl = ''
        if (uploadRes.code === 0 && uploadRes.data) {
          // API层已resolve了response.data，所以uploadRes就是data
          if (typeof uploadRes.data === 'string') {
            fileUrl = uploadRes.data
          } else if (uploadRes.data.realFileName) {
            fileUrl = uploadRes.data.realFileName
          }
        } else if (uploadRes.realFileName) {
          fileUrl = uploadRes.realFileName
        } else if (typeof uploadRes === 'string') {
          fileUrl = uploadRes
        }

        if (!fileUrl) {
          this.$message.error('文件上传失败，未获取到文件地址')
          return Promise.reject(new Error('文件上传失败'))
        }

        // 第二步：调用导入接口，传入fileUrl和communityId
        return importCommunityFundDetails({
          communityId: this.getCommunityId(),
          fileUrl: fileUrl
        })
      }).then(res => {
        if (res && res.code === 0) {
          this.$message.success('导入成功，共导入' + (res.data.successCount || 0) + '条记录')
          if (res.data.failCount && res.data.failCount > 0) {
            this.$message.warning(res.data.failCount + '条记录导入失败：' + (res.data.errorMsg || ''))
          }
          this.loadSummary()
          this.loadDetails()
        } else if (res) {
          this.$message.error(res.msg || '导入失败')
        }
      }).catch(err => {
        this.$message.error('导入失败：' + (err.message || '未知错误'))
      })
    },
    parseRemarkName(remark) {
      if (!remark) return ''
      const idx = remark.indexOf(' | ')
      return idx !== -1 ? remark.substring(0, idx) : remark
    },
    parseRemarkNote(remark) {
      if (!remark) return ''
      const idx = remark.indexOf(' | ')
      return idx !== -1 ? remark.substring(idx + 3) : ''
    },
    formatTimestamp(val) {
      if (!val) return ''
      // 如果是时间戳（纯数字），转换为日期字符串
      const num = Number(val)
      if (!isNaN(num) && num > 1000000000000) {
        const d = new Date(num)
        const y = d.getFullYear()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        const h = String(d.getHours()).padStart(2, '0')
        const min = String(d.getMinutes()).padStart(2, '0')
        const s = String(d.getSeconds()).padStart(2, '0')
        return y + '-' + m + '-' + day + ' ' + h + ':' + min + ':' + s
      }
      // 如果已经是日期字符串，直接返回
      return val
    }
  }
}
</script>

<style scoped>
.community-fund-manage {
  padding: 0 10px;
}

.vc-index-nav {
  padding: 10px;
  font-size: 16px;
  text-align: left;
  margin-bottom: 10px;
}

.margin-right-sm {
  margin-right: 5px;
}

.margin-left-sm {
  margin-left: 5px;
}

.fund-summary {
  margin-bottom: 20px;
}

.summary-card {
  text-align: center;
  padding: 10px 0;
}

.summary-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.summary-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
}

.summary-value.income {
  color: #67C23A;
}

.summary-value.expense {
  color: #F56C6C;
}

.balance-card {
  border-top: 3px solid #409EFF;
}

.income-card {
  border-top: 3px solid #67C23A;
}

.expense-card {
  border-top: 3px solid #F56C6C;
}

.filter-card {
  margin-bottom: 20px;
}

.table-card {
  margin-bottom: 20px;
}

.text-income {
  color: #67C23A;
  font-weight: bold;
}

.text-expense {
  color: #F56C6C;
  font-weight: bold;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
